/**
 * Search values as the address wrote them. The router parses search values as JSON (`?preview=1`
 * is the number 1), and a search validator that drops or retypes one makes it rewrite the address,
 * so account and membership routes keep their search as given and read values with these.
 */
export type RawSearch = Record<string, unknown>;

export const keepSearch = (search: RawSearch) => search;

/** The search as the URLSearchParams its address carried, for the shared parsers. */
export function searchParams(search: RawSearch) {
  return new URLSearchParams(
    Object.entries(search).flatMap(([name, value]) =>
      value === undefined || value === null ? [] : [[name, String(value)]],
    ),
  );
}

/** A value as text, or null when the address doesn't have it. */
export function searchText(search: RawSearch, name: string) {
  const value = search[name];
  return value === undefined || value === null ? null : String(value);
}
